import React, { useState } from 'react';
import { Modal, Button, Alert, Card, Table } from 'react-bootstrap';
import LoadingSpinner from '../common/LoadingSpinner';

const DeleteUserModal = ({ show, user, onConfirm, onClose }) => {
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    setError('');
    setSubmitting(true);

    const result = await onConfirm();
    setSubmitting(false);

    if (!result.success) {
      setError(result.error || 'Failed to delete user.');
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
  };

  return (
    <Modal show={show && !!user} onHide={handleClose} centered>
      <Modal.Header closeButton className="bg-danger-subtle">
        <Modal.Title>Delete User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <p>Are you sure you want to delete this user?</p>

        <Card>
          <Card.Body>
            <Table size="sm" className="mb-0">
              <tbody>
                <tr>
                  <th style={{ width: '120px' }}>Username:</th>
                  <td>{user?.username}</td>
                </tr>
                <tr>
                  <th>Display Name:</th>
                  <td>{user?.displayName}</td>
                </tr>
                <tr>
                  <th>Email:</th>
                  <td>{user?.emailAddress}</td>
                </tr>
                <tr>
                  <th>Agency:</th>
                  <td>{user?.agencyName}</td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>

        <Alert variant="danger" className="mt-3 mb-0">
          <strong>Warning:</strong> This action cannot be undone.
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={submitting}>
          {submitting ? (
            <LoadingSpinner inline message="Deleting..." />
          ) : (
            'Delete User'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteUserModal;